<template>
  <v-container fluid>
    <v-expansion-panel
      v-model="filterPanel"
      expand
    >
      <v-expansion-panel-content key="filterPanel">
        <template v-slot:header>
          <div>Server Side Filters</div>
        </template>
        <v-card>
          <v-card-text>
            <p>When filtering server side, filters need to be an exact match.</p>
            <v-container grid-list-xl fluid>
              <v-layout row wrap>
                <v-flex xs12 sm6 md1>
                  <v-select
                    label="Limit Results"
                    :items="[
                      50,
                      100,
                      250,
                      500,
                      1000
                    ]"
                    v-model="limit"
                  />
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-autocomplete
                    label="Customer"
                    :items="customerList"
                    v-model="customer"
                    item-value="key"
                    item-text="name"
                    clearable
                  />
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    label="User"
                    v-model="user"
                  />
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field
                    label="Job No"
                    v-model="jobNo"
                  />
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-text-field
                    label="Project ID"
                    v-model="projectId"
                  />
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-menu
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="startDate"
                        label="Start"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="startDate" @input="startDateMenu = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-text-field
                    label="Start Time"
                    mask="time"
                    v-model="startTime"
                  />
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-menu
                    v-model="endDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="endDate"
                        label="End"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="endDate" @input="endDateMenu = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-text-field
                    label="End Time"
                    mask="time"
                    v-model="endTime"
                  />
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-btn
                    color="primary"
                    block
                    @click="applyFilters"
                  >
                    Apply Filters
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card>
      <v-card-title>
        Audit Log
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="auditData"
        :search="search"
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <td>{{ props.item.time|formatDateTime }}</td>
          <td style="text-transform: capitalize;">{{ props.item.type }}</td>
          <td>{{ props.item.user }}</td>
          <td>{{ props.item.projectId }}</td>
          <td>{{ props.item.jobNo }}</td>
          <td>{{ props.item.customer }}</td>
          <td>{{ props.item.action }}</td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import { fireStore } from '../firebase'
import moment from 'moment'
export default {
  // props: ['customer', 'jobNo', 'project'],
  data () {
    return {
      limit: 50,
      jobNo: '',
      projectId: '',
      customer: '',
      user: '',
      startDate: moment().format('YYYY-MM-DD'),
      startDateMenu: false,
      startTime: '00:00',
      endDate: moment().add(1, 'day').format('YYYY-MM-DD'),
      endDateMenu: false,
      endTime: '00:00',
      listener: null,
      auditData: [],
      search: '',
      filterPanel: ['filterPanel'],
      pagination: {
        sortBy: 'time',
        descending: true
      },
      headers: [
        {
          value: 'time',
          text: 'Time'
        },
        {
          value: 'type',
          text: 'Action'
        },
        {
          value: 'user',
          text: 'User'
        },
        {
          value: 'projectId',
          text: 'Project'
        },
        {
          value: 'jobNo',
          text: 'Job'
        },
        {
          value: 'customer',
          text: 'Customer'
        },
        {
          value: 'action',
          text: 'Details'
        }
      ]
    }
  },
  beforeDestroy () {
    this.listener()
  },
  created () {
    this.getAuditLog()
    this.$store.dispatch('fetchCustomers')
  },
  methods: {
    applyFilters () {
      this.filterPanel = []
      this.listener()
      this.getAuditLog()
    },
    getAuditLog () {
      let end = moment(this.endDate + ' ' + this.endTime).endOf('day').format('x') * 1
      let start = moment(this.startDate + ' ' + this.startTime).startOf('day').format('x') * 1
      let ref = fireStore.collection('AuditLog')
      let query = ref.where('time', '<=', end).where('time', '>=', start)
      if (this.jobNo) {
        query = query.where('jobNo', '==', this.jobNo)
      }
      if (this.user) {
        query = query.where('user.Name', '==', this.user)
      }
      if (this.projectId) {
        query = query.where('projectId', '==', this.projectId)
      }
      if (this.customer) {
        query = query.where('customer', '==', this.customer)
      }
      try {
        this.listener = query.orderBy('time', 'desc').limit(this.limit).onSnapshot((querySnapshot) => {
          let auditData = []
          querySnapshot.forEach((doc) => {
            let data = doc.data()
            data.customer = this.customerNameFromID(data.customer)
            if (!data.user) {
              data.user = 'Missing'
            } else {
              data.user = data.user.Name
            }
            auditData.push(data)
          })
          this.auditData = auditData
        })
      } catch (error) {
        alert(error)
      }
    },
    customerNameFromID (id) {
      const index = this.customerList.findIndex(customer => {
        return customer.key === id
      })
      return index > -1 ? this.customerList[index].name : null
    }
  },
  filters: {
    formatDateTime (val) {
      return moment(val).format('DD/MM/YYYY HH:mm')
    }
  },
  computed: {
    customerList () {
      return this.$store.getters.customers
    }
  }
}
</script>


// WEBPACK FOOTER //
// AuditLog.vue?696dc520